module.exports = __webpack_public_path__ + "media/svg/talent_light_horizontal-996ae5be.svg";